import React, { createRef } from 'react'
import styled from 'styled-components'
import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'
import { SceneChangedEvent, ChapterChangedEvent } from '../lib/messages'

const Container = styled.div``

interface IProps {
  title: string
}

class Chapter extends IEventedComponent<IProps, {}> {
  scenes = new Set<number>()

  componentDidMount() {
    const elements = this.ref.current?.getElementsByClassName('scene') || []
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLDivElement
      const sceneIndex = parseInt(element?.dataset?.sceneIndex || '-1')
      if (sceneIndex >= 0 && this.scenes.has(sceneIndex)) {
        console.error(
          `duplicate scene index (${sceneIndex}) found in chapter ${this.props.title}`
        )
      }
      this.scenes.add(sceneIndex)
    }

    this.subscribe(messageTypes.onSceneChanged, this.handleActivateScene)
  }

  handleActivateScene = (message: SceneChangedEvent) => {
    if (this.scenes.has(message.sceneIndex)) {
      this.publish<ChapterChangedEvent>(messageTypes.onChapterChanged, {
        title: this.props.title
      })
    }
  }

  ref = createRef<HTMLDivElement>()

  render() {
    return (
      <Container ref={this.ref} className="chapter">
        {this.props.children}
      </Container>
    )
  }
}

export default Chapter
